// Add Themes as per your requirements
export const dark = {
	body: "#ede5db", // light shade
	text: "#201f1d",
	bodyRgba: "237, 229, 219",
	navRgba: "212, 200, 185",
	textRgba: "255, 255, 255",

	nav: "#d4c8b9", // brown shade

	fontxs: "0.75em", //1em = 16px
	fontsm: "0.875em",
	fontmd: "1em",
	fontlg: "1.25em",
	fontxl: "2em",
	fontxxl: "3em",
	fontxxxl: "5em",
	fontBig: "10em",

	navHeight: "5rem",
};
